export default __webpack_public_path__ + "static/media/solar-bg2.8382a2bd.png";